// text-image-width-slider section js

jQuery('.fadeidermifyslider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 750,
  fade: true,
  cssEase: 'linear',
 prevArrow: false,
    nextArrow: false
});


// horizontal text slider js

const scrollers = document.querySelectorAll(".scroller");

// If a user hasn't opted in for recuded motion, then we add the animation
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
}

function addAnimation() {
  scrollers.forEach((scroller) => {
    // add data-animated="true" to every `.scroller` on the page
    scroller.setAttribute("data-animated", true);

    // Make an array from the elements within `.scroller-inner`
    const scrollerInner = scroller.querySelector(".scroller__inner");
    const scrollerContent = Array.from(scrollerInner.children);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  });
}

// Review slider js

$('.reviews-slider .slider-wrapper').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  dots:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


// tabs js

var $ = jQuery;
  $('.idermifytabcollectionmain .tab-menu li a').on('click', function(){
		   	var target = $(this).attr('data-rel');
			$('.tab-menu li a').removeClass('active');
		   	$(this).addClass('active');
		   	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
		   	return false;
  });



// tab slider js
setTimeout(function () {
  $('.tabcollectionsliderone').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false, // default: no dots
    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false
        }
      },
      {
        breakpoint: 600, // small mobile
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          nav:false,
        }
      },
      {
        breakpoint: 480, // extra small mobile
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          nav:false,
        }
      }
    ]
  });
}, 600);

jQuery('.collecttabtwobtn').click(function(){
  $('.tabcollectionslider2').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false, // default: no dots
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          nav:false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          nav:false,
        }
      }
    ]
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const quickViewButtons = document.querySelectorAll(".quick-view-btn");
  const modal = document.getElementById("quick-view-modal");
  const modalContent = document.getElementById("quick-view-details");
  const closeModal = document.querySelector(".close-modal");

  quickViewButtons.forEach((button) => {
    button.addEventListener("click", async function () {
      const productHandle = this.dataset.handle;
      
      try {
        const response = await fetch(`/products/${productHandle}.json`);
        const data = await response.json();
        const product = data.product;

        let imageUrl = product.images && product.images.length > 0 ? product.images[0].src : "https://via.placeholder.com/500x500?text=No+Image";

        modalContent.innerHTML = `
         <div class="headermodal"> <h2>${product.title}</h2></div>
       <div class="quickgridsec">   <div class="quickleftsec">  <img src="${imageUrl}" width="100%" onerror="this.src='https://via.placeholder.com/500x500?text=Image+Not+Found'"></div>
          <div class="quickrightsec"> <p>${product.body_html}</p>
          <p><strong>Price:</strong> ₹${product.variants[0].price}</p>
          <button class="add-to-cart" data-id="${product.variants[0].id}">Add to Cart</button></div></div>
        `;

        modal.style.display = "block";
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    });
  });

  closeModal.addEventListener("click", function () {
    modal.style.display = "none";
  });

  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("add-to-cart")) {
      const variantId = event.target.dataset.id;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }).then(() => {
        alert("Product added to cart!");
        modal.style.display = "none";
      });
    }
  });
});


// card slider js

$('.card_productslider').slick({
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  nav:true,
});

setTimeout(function(){
$('.product .card_productslider').slick({
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  nav:true,
});
},3000);
// collection tab js

document.addEventListener("DOMContentLoaded", function () {
  if(document.body.classList.contains('collection')){
    var currentUrl = window.location.href;
    var urlArray = currentUrl.split("/");
    var lastPart = urlArray[urlArray.length - 1].toLowerCase(); // Convert to lowercase

    document.querySelectorAll(".collection-tab-main h1.collection-tab-text").forEach(function (tab) {
        var tabText = tab.textContent.trim().toLowerCase().replace(/\s+/g, "-"); // Convert to lowercase & replace spaces with hyphens

        if (tabText === lastPart) {
            tab.classList.add("active"); // Add 'active' class if matched
        }
    });
    }
});


// cart drawer js

$(document).ready(function () {
  // Function to initialize Slick
  function initSlick() {
    let $slider = $('.cart_recommended_slider');
    
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick'); // Destroy the existing instance
    }
    
    $slider.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
    });
  }

  // Check when .drawer gets 'active' class
  $(document).on('classChange', '.drawer', function () {
    if ($(this).hasClass('active')) {
      initSlick();
    }
  });

  // MutationObserver for class changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if ($(mutation.target).hasClass('active')) {
        initSlick();
      }
    });
  });

  observer.observe(document.querySelector('.drawer'), { attributes: true, attributeFilter: ['class'] });

  // Reinitialize Slick when quantity buttons are clicked
  $(document).on('click', 'div#CartDrawer button.quantity__button', function () {
  setTimeout(function(){
    initSlick();
    },1000);
  });
 $(document).on('click', 'div#CartDrawer button.button.button--tertiary.cart-remove-button', function () {
  setTimeout(function(){
    initSlick();
    },1000);
  });

  
});




